import {IResolvedActivity} from "../contexts/Activity.tsx";
import {isMobile} from "./isMobile.ts";

export const calcItem = (item:IResolvedActivity) => {
    const center = {
        x : item.position.parentWidth / 2,
        y : item.position.parentHeight / 2
    }
    const DISTINCTION = isMobile() ? 0 : 125;
    item.r = Math.sqrt( Math.pow(center.x - (item.position.x + DISTINCTION),2) +  Math.pow(center.y - (item.position.y + DISTINCTION),2) );
    item.scale = Math.max(
        Math.abs(center.x - (item.position.x + DISTINCTION)) / center.x,
        Math.abs(center.y - (item.position.y + DISTINCTION)) / center.y
    );
    return item;
}